<template>
  <div class="clearfix" v-if="!pageLoad">
    <div class="spinner-grow text-danger" style="width: 3rem; height: 3rem;margin-top:25vh; margin-left:42%; margin-bottom:5vh" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
  </div>
  <div v-if="pageLoad" class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25 flex-wrap gap-10">
      <div class="d-flex align-items-center flex-wrap gap-10">
        <div class="position-relative" style="min-width: 220px; max-width: 300px;">
          <input
            v-model="searchQuery"
            type="text"
            class="form-control shadow-none fw-medium text-black fs-md-15 fs-lg-16"
            :placeholder="$t('balances.search')"
          />
        </div>
      </div>
      <div class="d-flex align-items-center" v-if="canManageBalanceStatus && current_permissions('list_providers')">
        <button
          class="default-btn position-relative transition border-0 fw-medium text-white pt-11 pb-11 ps-25 pe-25 pt-md-12 pb-md-12 ps-md-30 pe-md-30 rounded-1 fs-md-15 fs-lg-16 d-inline-block me-10 mb-10 mb-lg-0"
          type="button"
          data-bs-toggle="modal"
          data-bs-target="#companyModal"
          style="background-color: #EB9355;"
          @click="initField"
        >
          Ajouter un balance
          <i class="flaticon-plus position-relative ms-5 fs-12"></i>
        </button>
      </div>
    </div>
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div class="table-responsive">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('balances.code') }}
              </th>
              <th v-if="current_permissions('list_providers')" scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('balances.country') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 ps-0">
                {{ $t('balances.name') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('balances.type') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('balances.status') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0">
                {{ $t('balances.balance') }}
              </th>
              <th scope="col" class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0 text-end pe-0"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(balanceItem) in paginatedBalances" :key="balanceItem.code">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ balanceItem.code }}
              </td>
              <td v-if="current_permissions('list_providers')" class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ balanceItem.country?.name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ balanceItem.operator?.mnoName }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ balanceItem.balanceType }}
              </td>

              <!-- Colonne STATUS : éditable pour SUPERADMIN / BUSINESS / SUPPORT -->
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <div class="d-flex align-items-center gap-8" v-if="canManageBalanceStatus">
                  <select
                    class="form-select form-select-sm shadow-none"
                    style="min-width: 130px;"
                    :value="balanceItem.status"
                    :disabled="updatingCode === balanceItem.code"
                    @change="onStatusChange($event, balanceItem)"
                  >
                    <option value="ACTIVE">{{ $t('balances.active') || 'ACTIVE' }}</option>
                    <option value="INACTIVE">{{ $t('balances.inactive') || 'INACTIVE' }}</option>
                  </select>
                  <span v-if="updatingCode === balanceItem.code" class="spinner-border spinner-border-sm text-secondary" role="status"></span>
                </div>
                <span v-else>{{ balanceItem.status }}</span>
              </td>

              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ balanceItem.balance?.toLocaleString()}}
              </td>
              <td class="shadow-none lh-1 fw-medium text-body-tertiary text-end pe-0">
                <div class="dropdown" v-if="canManageBalanceStatus && current_permissions('list_providers')">
                  <button class="dropdown-toggle lh-1 bg-transparent border-0 shadow-none p-0 transition" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <i class="flaticon-dots"></i>
                  </button>
                  <ul class="dropdown-menu">
                    <!-- <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#companyModal1" @click="showTransfert(balanceItem.code)">
                        <i class="flaticon-file-1 position-relative ms-5 top-2 fs-15"></i>
                        <span class="">{{ $t('balances.transfer') }}</span>
                      </a>
                    </li> -->
                    <li>
                      <a class="dropdown-item d-flex align-items-center" style="color: red;" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#filterLeadModal" @click="showScreen(balanceItem.code)">
                        <i class="flaticon-delete lh-1 me-8 position-relative top-1"></i>
                        <span class="">{{ $t('balances.delete') }}</span>
                      </a>
                    </li>
                    <li>
                      <a class="dropdown-item d-flex align-items-center" href="javascript:void(0);" data-bs-toggle="modal" data-bs-target="#companyModal" @click="showBalance(balanceItem.code)">
                        <i class="flaticon-pen lh-1 me-8 position-relative top-1"></i>
                        <span class="">{{ $t('balances.edit') }}</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div v-if="filteredTotal>0" class="pagination-area d-md-flex mt-15 mt-md-25 mb-0 justify-content-between align-items-center">
        <p v-if="filteredTotal>10" class="mb-0 text-paragraph">
          {{ $t('balances.showing') }} <span class="fw-bold">{{ page*10 }}</span> {{ $t('balances.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('balances.results') }}
        </p>
        <p v-if="filteredTotal<=10" class="mb-0 text-paragraph">
          {{ $t('balances.showing') }} <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('balances.outOf') }}
          <span class="fw-bold">{{ filteredTotal }}</span> {{ $t('balances.results') }}
        </p>
        <nav class="mt-15 mt-md-0">
          <ul class="pagination mb-0">
            <li v-if="(page-1)>0" class="page-item">
              <a class="page-link" @click="goToPage(page-1)" aria-label="Previous">
                <i class="flaticon-chevron-1"></i>
              </a>
            </li>
            <li v-for="(numPage) in numPages" :key="numPage" class="page-item">
              <a v-if="numPage==page" class="page-link active" href="#">{{ numPage }}</a>
              <a v-else class="page-link" @click="goToPage(numPage)">{{ numPage }}</a>
            </li>
            <li v-if="(page+1)<=numPages" class="page-item">
              <a class="page-link" @click="goToPage(page+1)" aria-label="Next">
                <i class="flaticon-chevron"></i>
              </a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>

  <!-- Modal Delete Confirmation -->
  <div class="modal fade" id="filterLeadModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-sm modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h1 class="modal-title fs-5">{{ $t('balances.alert') }}</h1>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="cancel()"></button>
        </div>
        <div class="modal-body">
          <div style="">
            <h6 v-if="errors==''" class="text-red fw-bold mb-0 text-center" style="color: red;">{{ $t('balances.confirmDelete') }}</h6>
          </div>
          <div v-if="errors!==''">
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">code: {{ errorId}}</h6>
            <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn default-outline-btn bg-transparent" style="background-color: #FFF;" data-bs-dismiss="modal" @click="cancel()">
            {{ $t('balances.no') }}
          </button>
          <button :disabled="!btnLoad" type="button" class="btn" style="background-color: #EB9355;" @click="deleteBalance()">
            <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
            <span style="color: #FFF;">{{ $t('balances.yes') }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal Create/Edit Balance -->
  <div class="modal fade" id="companyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-centered">
      <div class="modal-content">
        <form @submit.prevent="save">
          <div class="modal-header">
            <h1 class="modal-title fs-5">{{ edit == 0 ? $t('balances.addBalance') : $t('balances.editBalance') }}</h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div v-if="errors!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errorId}}</h6>
              <h6 class="text-red fw-bold mb-0 text-center" style="color: red;">{{ errors}}</h6>
            </div>
            <div v-if="success!==''" style="margin-top: 5%;">
              <h6 class="text-red fw-bold mb-0 text-center" style="color:green">{{ success}}</h6>
            </div>
            <div class="form-group mb-15 mb-sm-20 mb-md-25">
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('balances.balanceName') }}</label>
                  <div>
                    <input type="text" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('balances.balanceNamePlaceholder')" v-model="formValues.name" :class="{ 'is-invalid': errorsBis['name'] }" id="name" @blur="validate('name')" />
                    <span class="invalid-feedback">{{ errorsBis['name']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('balances.balanceType') || 'Type de balance' }}</label>
                  <div>
                    <select
                      class="form-select fs-md-15 text-black shadow-none"
                      v-model="formValues.balanceType"
                      :class="{ 'is-invalid': errorsBis['balanceType'] }"
                      id="balanceType"
                      @change="validate('balanceType')"
                    >
                      <option value="" disabled>{{ $t('balances.selectBalanceType') || 'Sélectionner un type' }}</option>
                      <option value="BOTH">BOTH</option>
                      <option value="PAYOUT">PAYOUT</option>
                      <option value="PAYIN">PAYIN</option>
                    </select>
                    <span class="invalid-feedback">{{ errorsBis['balanceType'] }}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('balances.country') }}</label>
                  <div>
                    <select
                      class="form-select fs-md-15 text-black shadow-none"
                      v-model="formValues.country"
                      :class="{ 'is-invalid': errorsBis['country'] }"
                      id="country"
                      @change="validate('country')"
                    >
                      <option value="" disabled>{{ $t('balances.selectCountry') || 'Sélectionner un pays' }}</option>
                      <option v-for="c in countries" :key="c.code" :value="c.code">{{ c.name }}</option>
                    </select>
                    <span class="invalid-feedback">{{ errorsBis['country']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('balances.operator') || 'Opérateur' }}</label>
                  <div>
                    <select
                      class="form-select fs-md-15 text-black shadow-none"
                      v-model="formValues.operator"
                      :class="{ 'is-invalid': errorsBis['operator'] }"
                      id="operator"
                      @change="validate('operator')"
                    >
                      <option value="" disabled>{{ $t('balances.selectOperator') || 'Sélectionner un opérateur' }}</option>
                      <option v-for="o in operators" :key="o.code" :value="o.code">{{ o.name }}</option>
                    </select>
                    <span class="invalid-feedback">{{ errorsBis['operator']}}</span>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('balances.balanceLimit') || 'Limite du balance' }}</label>
                  <div>
                    <input type="number" class="form-control flatpickr shadow-none fw-medium text-black fs-md-15 fs-lg-16" :placeholder="$t('balances.balanceLimitPlaceholder') || 'Laisser vide si aucune limite'" v-model="formValues.balanceLimit" :class="{ 'is-invalid': errorsBis['balanceLimit'] }" id="balanceLimit" @blur="validate('balanceLimit')" />
                    <span class="invalid-feedback">{{ errorsBis['balanceLimit']}}</span>
                  </div>
                </div>
                <div class="col-md-6">
                  <label class="d-block text-black fw-semibold mb-10">{{ $t('balances.status') }}</label>
                  <select class="form-select fs-md-15 text-black shadow-none" v-model="formValues.status" id="status">
                    <option value="ACTIVE">ACTIVE</option>
                    <option value="INACTIVE">INACTIVE</option>
                  </select>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="submit" class="btn text-white" style="background-color: #EB9355;">
              <span v-if="!btnLoad" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true" style="color: #FFF;"></span>
              <i class="flaticon-plus position-relative ms-5 fs-12" style="color: #FFF;"></i>
              {{ edit == 0 ? $t('balances.save') : $t('balances.edit') }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>

  <div id="snackbar"></div>
</template>

<script setup  lang="ts">
import {ref, onMounted,reactive,inject, computed } from "vue";
import axios from 'axios';
import router from '../../router/index'
import { useRouter } from 'vue-router';
import { useI18n } from "vue-i18n";
import * as yup from 'yup';
import { Organization,Balance } from "@/utils/Model";
import { useTableFilter } from "../../utils/UseTablefilter";

import {current_permissions} from '../../utils/permission';
import {validate_phone_number,showToast,checkSessionValidate} from "@/utils/function";

const backApi=inject('back');

const btnLoad = ref(true);
const { t } = useI18n();

const loader = ref(false);

let token: string|null = localStorage.getItem('login_token');
let codeOrganization: string|null = localStorage.getItem('organization_code');
let codeUser: string|null = localStorage.getItem('code');
let role: string|null = localStorage.getItem('role');

// Rôles autorisés à gérer les balances (création/édition/statut)
const allowedStatusRoles = ['SUPERADMIN', 'BUSINESS', 'SUPPORT'];
const canManageBalanceStatus = computed(() => allowedStatusRoles.includes((role || '').toUpperCase()));

const updatingCode = ref('');

const selectedValidation = ref('');

const balance =ref(new Array<Balance>());
const countries = ref([] as any[]);
const operators = ref([] as any[]);

let edit = 0;
let itemCode = '';
let selectedOrganization = '';

const {
  searchQuery,
  paginatedData: paginatedBalances,
  filteredTotal,
  page,
  numPages,
  pageSize,
  showingFrom,
  showingTo,
  goToPage,
} = useTableFilter(
  balance,
  [
    (b: any) => b.code,
    (b: any) => b.country?.name,
    (b: any) => b.operator?.mnoName,
    (b: any) => b.balanceType,
    (b: any) => b.status,
    (b: any) => b.balance,
  ],
  15
);



  let data = [];
 
  const errors = ref('');  
  const errorId = ref('');  
  const success = ref('');
  const errorsBis = {'name':'','country':'','operator':'','balanceLimit':'','balanceType':''};
  const pageLoad = ref(false);

  const formValues = reactive({
    name: "",
    balanceType: "",
    balanceLimit: null,
    status: "ACTIVE",
    operator: "",
    country: "",
    // Champs utilisés par le formulaire de transfert (sendMoney / showTransfert)
    amount: 0,
    phone: "",
    first_name: "",
    last_name: "",
  });


  const schema = yup.object({
      name: yup.string().required('Le nom est requis'),
      balanceType: yup.string().oneOf(['BOTH', 'PAYOUT', 'PAYIN'], 'Type de balance invalide').required('Le type de balance est requis'),
      balanceLimit: yup.number().nullable().transform((v, orig) => (orig === '' ? null : v)),
      status: yup.string().required('Le statut est requis'),
      operator: yup.string().required("L'opérateur est requis"),
      country: yup.string().required('Le pays est requis'),
  });



function formatDateFr(value){
    if(value){
        const year = value.getFullYear();
        let month =value.getMonth() + 1;
        month = month<10?'0'+month:month;
        let day = value.getDate();  
        day = day<10?'0'+day:day;      
        return day+'/'+month+'/'+year;
        
    }
}
const initField = () =>{
  formValues.name = '';
  formValues.balanceType = '';
  formValues.balanceLimit = null;
  formValues.status = 'ACTIVE';
  formValues.operator = '';
  formValues.country = '';
  errors.value = '';
  errorId.value = '';
  success.value = '';
  edit=0;
}

// Liste des pays pour le select "country" du formulaire
const getCountries = () => {
  axios.get(backApi+'/secure/countries/', {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    countries.value = response.data.data ?? response.data;
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  });
}

// Liste des opérateurs pour le select "operator" du formulaire
// L'API pagine les résultats (ex: 10 items/page, 14 au total sur 2 pages),
// on boucle donc sur toutes les pages via pagination.nextPage jusqu'à
// récupérer l'intégralité des opérateurs avant de les affecter à operators.value.
const getOperators = async (page = 1, accumulated: any[] = []) => {
  try {
    const response = await axios.get(backApi + '/secure/operators/', {
      params: { page },
      headers: {
        Authorization: `Bearer ${token}`
      }
    });

    const pageData = response.data.data ?? response.data;
    const merged = accumulated.concat(pageData);
    const pagination = response.data.pagination;

    if (pagination && pagination.nextPage) {
      // il reste des pages à charger, on continue la récupération
      await getOperators(pagination.nextPage, merged);
    } else {
      operators.value = merged;
    }
  } catch (error: any) {
    if (error.response) {
      if (error.response.status === 401) {
        router.push('/')
      }
    }
  }
}

// NB: pour un SUPERADMIN on garde le filtre ?status=ACTIVE (toutes organisations),
// pour les autres rôles on filtre en plus par organisation. Auparavant "param"
// était calculé mais jamais utilisé dans l'URL (bug), et la réponse était
// assignée en bloc (response.data) au lieu du tableau qu'elle contient
// (response.data.data), ce qui cassait la pagination/recherche côté front.
const getBalance = (arg=1) =>{
    let param = '';
    param = (role=='SUPERADMIN')?'?status=ACTIVE':`?status=ACTIVE&organization=${codeOrganization}`
    axios.get(backApi+'/secure/provider/balance/'+param,{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        balance.value = response.data.data ?? response.data;
        data  = balance.value;  
        // total.value=parseInt(response.data.pagination.total);
        // page.value=parseInt(response.data.pagination.page);
        // pagesLeft.value=parseInt(response.data.pagination.pagesLeft);
        // currentPage.value=parseInt(response.data.pagination.currentPage);
        // numPages.value=parseInt(response.data.pagination.numPages);

    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }   
              
          }
  });
}

const showBalance = (code) =>{
    axios.get(backApi+'/secure/balance/'+code+'/show',{
      headers: {

            Authorization: `Bearer ${token}`
      }
    })
    .then((response) => {
        formValues.name = response.data.name;
        formValues.balanceType = response.data.balanceType ?? '';
        formValues.balanceLimit = response.data.balanceLimit ?? null;
        formValues.status = response.data.status ?? 'ACTIVE';
        formValues.operator = response.data.operator?.code ?? response.data.operator ?? '';
        formValues.country = response.data.country?.code ?? response.data.country ?? '';

        itemCode = response.data.code;

        edit=1;
        console.log(response.data);
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                console.log(error.response);
              }   
              
          }
  });
}

const showTransfert = (code) =>{
    // +arg
     axios.get(backApi+'/secure/contactbook/'+code+'/show',{    
      headers: {
            
            Authorization: `Bearer ${token}`
      } 
    })
    .then((response) => {        
        // balance.value = response.data;  //.data.balance 
        formValues.phone=  response.data.contact;  
        formValues.first_name=  response.data.first_name; 
        formValues.last_name=  response.data.last_name; 
        itemCode = response.data.code;
              
           
        console.log(response.data);
    }).catch((error) => {
          if( error.response){              
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                console.log(error.response);
              }   
              
          }
  });
}


/**
 * Change le statut d'un balance via /secure/provider/balance/{code}/status
 * Autorisé uniquement pour SUPERADMIN / BUSINESS / SUPPORT (cf. canManageBalanceStatus).
 */
const changeBalanceStatus = (balanceItem, newStatus) => {
  if (!canManageBalanceStatus.value) {
    return;
  }

  const oldStatus = balanceItem.status;
  if (oldStatus === newStatus) {
    return;
  }

  updatingCode.value = balanceItem.code;

  axios.put(`${backApi}/secure/provider/balance/${balanceItem.code}/status`, {
      status: newStatus
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    })
    .then((response) => {
      balanceItem.status = newStatus;
      showToast("Statut mis à jour avec succès", "green");
    })
    .catch((error) => {
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/');
        } else {
          errorId.value = error.response.data?.errorId ?? '';
          errors.value = error.response.data?.message ?? "une erreur inattendue est apparue";
          showToast(errors.value, "red");
        }
      }
      // on remet l'ancien statut en cas d'échec
      balanceItem.status = oldStatus;
    })
    .finally(() => {
      updatingCode.value = '';
    });
}

const onStatusChange = (event, balanceItem) => {
  changeBalanceStatus(balanceItem, event.target.value);
}

const showScreen = (code)=>{ 
  itemCode=code;
  
}

const cancel = () =>{
  itemCode="";
  errorId.value="";
  errors.value="";
}

const save =()=>{
  if (edit==0){
    storeBalance()
  }else{
    updateBalance()
    
  }
  
}


const sendMoney =()=>{
btnLoad.value=false;
if(parseFloat(formValues.amount)>0  && selectedValidation.value!==''){
try {  
  schema.validateSync(formValues);

  axios.post(`${backApi}/secure/transactions/init`,{
    clientId:formValues.first_name+" "+formValues.last_name,    
    operator:selectedValidation.value,
    amount:parseFloat(formValues.amount),
    mobile:formValues.phone,
    operationType:parseInt(process.env.VUE_APP_PAYOUT_OPTTYPE),
    successUrl: "https://billing.api/success",
    errorUrl: "https://billing.api/error"
        }, {  
      headers: {            
            Authorization: `Bearer ${token}`,
           'Content-Type':'application/json',
      }       
      }).then((response) => {  
        btnLoad.value=true;
        if(response.status === 201){      
          //router.go();
           
          showToast("Transfert réussi","green");
          formValues.amount=0;
          formValues.phone='';
          selectedValidation.value='N';          
        }      
        
    }).catch((error) => {
      if( error.response){
              if(error.response.status === 401){
                router.push('/')
                
              }else{
                errorId.value=error.response.data.errorId;
                errors.value=error.response.data.message;
              } 
              
          }
  });
} catch (error) {
        console.error(error);        
         errors.value="une erreur inattendue est apparue"
      
}
}else{
  if(parseFloat(formValues.amount)==0){
      showToast("Veuillez saisir un montant correct","red");
  }else{
      showToast("Veuillez sélectionner un opérateur","red");
  }
  
}
btnLoad.value=true;
}

const storeBalance = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);

    axios.post(`${backApi}/secure/provider/balance/new`, {
      name: formValues.name,
      balanceType: formValues.balanceType,
      balanceLimit: formValues.balanceLimit === '' ? null : formValues.balanceLimit,
      status: formValues.status,
      operator: formValues.operator,
      country: formValues.country,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200 || response.status === 201) {
        console.log(response);
        showToast("Enregistrement effectué avec succès", "green");
        router.go();
      }

    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')

        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }

      }
    });
  } catch (error) {
    btnLoad.value = true;
    errors.value = "une erreur inattendue est apparue"

  }

}

const updateBalance = () => {
  btnLoad.value = false;
  try {
    schema.validateSync(formValues);

    axios.put(`${backApi}/secure/balance/${itemCode}/edit`, {
      name: formValues.name,
      balanceType: formValues.balanceType,
      balanceLimit: formValues.balanceLimit === '' ? null : formValues.balanceLimit,
      status: formValues.status,
      operator: formValues.operator,
      country: formValues.country,
    }, {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      }
    }).then((response) => {
      btnLoad.value = true;
      if (response.status === 200) {
        showToast("Modification effectuée avec succès", "green");
        router.go();
      }

    }).catch((error) => {
      btnLoad.value = true;
      if (error.response) {
        if (error.response.status === 401) {
          router.push('/')

        } else {
          errorId.value = error.response.data.errorId;
          errors.value = error.response.data.message;
        }

      }
    });
  } catch (error) {
    btnLoad.value = true;
    errors.value = "une erreur inattendue est apparue"

  }

}

const deleteBalance =()=>{
  btnLoad.value=false;
try {   
  // alert(itemCode);
  const headers = {
  'Authorization':  `Bearer ${token}`
  }
const data = {
  code: itemCode
}
  axios.delete(`${backApi}/secure/balance/delete`, {headers, data})
  .then(response => {
    if(response.status === 200){ 
      btnLoad.value=true;
          console.log(response);          
          router.go();  
        }   
})
.catch(error => {
  if( error.response){
      
      if(error.response.status === 401){
        router.push('/')
        
      }else{
        errorId.value=error.response.data.errorId;
        errors.value=error.response.data.message;
      } 
      
  }
});

} catch (error) {
        // console.log(error);        
         errors.value="une erreur inattendue est apparue"
         
              
}

}

function validate(field) {
      schema
        .validateAt(field, formValues)
        .then(() => {
          errorsBis[field] = "";
        })
        .catch(err => {
          errorsBis[field] = err.message;          
        });
        errors.value=''
}

const exportExcel = () =>{
  
  import("../../utils/Export2Excel").then((excel)=>{
    // const data = transactions.value;
    const Header =["CODE RECHARGEMENT","DESCRIPTION","MONTANT","DATE","STATUT"];
    const Fields = ["code","description","amount","createdAt","status"];
    // console.log(data);
    const dataForExcel= formatJSon(Fields,data);
    // console.log(dataForExcel);
    excel.export_json_to_excel({     
      header:Header,
      data:dataForExcel,
      sheetName:"Feuil1",
      filename:"rechargement",      
      autoWidth: true,
      bookType:"xlsx",
  });
  });
}

function formatJSon(FilterData,JsonData){
  return JsonData.map((v)=>FilterData.map(j=>{
      return v[j];
    }));
}


 onMounted(async () => { 
  checkSessionValidate(1);
   getBalance();
   getCountries();
   getOperators();

   setTimeout(function () {
    pageLoad.value=true; 
         },1000)
 
});
</script>